// extracted by mini-css-extract-plugin
export default {"wrapper":"Retry_wrapper__V0doI","error":"Retry_error__73D8a"};